import { CardTitle } from "@/components/ui/card";

import { CardDescription } from "@/components/ui/card";

export default function ReportsPage() {
  return (
    <div className="container mx-auto py-6">
      <div className="flex justify-between items-center">
        <div>
          <CardTitle className="text-2xl font-bold">Reports</CardTitle>
          <CardDescription>View and manage reports, analytics and KPIs</CardDescription>
        </div>
      </div>
      <div className="h-6"></div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        <div className="p-6 border rounded-lg shadow-sm">
          <h2 className="font-semibold text-lg mb-2">Active Requests</h2>
          <p className="text-3xl">8</p>
        </div>
        <div className="p-6 border rounded-lg shadow-sm">
          <h2 className="font-semibold text-lg mb-2">Resource Utilization</h2>
          <p className="text-3xl">76%</p>
        </div>
      </div>
    </div>
  );
} 